import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useModal } from 'mui-modal-provider';
import { useDeleteClientField } from '../../../../sic-lib/api/hooks/useClientFields';
import { FieldValidationType } from '../../../../sic-lib/enums/FieldValidationType';
import { ClientField } from '../../../../sic-lib/types/ClientField';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';
import IconButtonLoading from '../../../Shared/IconButtonLoading/IconButtonLoading';

interface Props {
    config: ClientField;
    onToggleHandler: () => void;
}

export default function ClientFieldsItem({ config, onToggleHandler }: Props) {
    const { showModal } = useModal();
    const { mutate: deleteField, isPending: isLoading } = useDeleteClientField();

    const handleShowConfirmDelete = () => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Delete Field',
            description: 'This field will be permanently deleted',
            onConfirm: async () => deleteField(config.fieldId),
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <Grid container direction="row" wrap="wrap">
            <Grid item xs={true}>
                <Grid container direction="column" wrap="nowrap">
                    <Grid item xs="auto">
                        <Typography component="p" variant="body1" paddingTop="12px">
                            {config.label}
                        </Typography>
                    </Grid>
                    <Grid item xs="auto" container direction="row">
                        <Grid item xs="auto">
                            <FormControlLabel
                                label="Unique value"
                                labelPlacement="end"
                                control={
                                    <Checkbox
                                        color="primary"
                                        name="fieldIsUnique"
                                        checked={config.isUnique}
                                        disabled={true}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs="auto">
                            <FormControlLabel
                                label="Filterable field"
                                labelPlacement="end"
                                control={
                                    <Checkbox
                                        color="primary"
                                        name="fieldIsFilterable"
                                        checked={config.isFilterable}
                                        disabled={true}
                                    />
                                }
                            />
                        </Grid>
                        {(config.validationType === FieldValidationType.email ||
                            config.validationType === FieldValidationType.usMobilePhone) && (
                            <Grid item xs="auto">
                                <FormControlLabel
                                    label="Is verifiable field"
                                    labelPlacement="end"
                                    control={
                                        <Checkbox
                                            color="primary"
                                            name="isVerifiable"
                                            checked={config.isVerifiable}
                                            disabled={true}
                                        />
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs="auto">
                <Grid container direction="row" wrap="nowrap" spacing={0}>
                    <Grid item xs="auto">
                        <IconButtonLoading
                            tooltip="Remove"
                            showLoading={isLoading}
                            onClick={handleShowConfirmDelete}
                        >
                            <DeleteIcon />
                        </IconButtonLoading>
                    </Grid>
                    <Grid item xs="auto">
                        <IconButtonLoading
                            tooltip="Edit"
                            showLoading={false}
                            onClick={onToggleHandler}
                        >
                            <EditIcon />
                        </IconButtonLoading>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}
